'use strict'

function clean() {
    var preloader = $('#page-preloader'),
		spinner = preloader.find('.spinner');
    spinner.fadeOut();
    preloader.delay(350).fadeOut('slow');
}

function show() {
    var preloader = $('#page-preloader'),
		spinner = preloader.find('.spinner');    
    preloader.show();
    spinner.delay(350).show();
}

module.exports = {
    clean: clean,
    show: show
};
